import React, { useState } from 'react'
import CommonModal from '../../pages/Settings/components/ResetContext/components/DumpModal'
import { useUsersContext } from '../../context/usersContext'
import SvgIcon from "../icons";
import LocalPostOfficeIcon from '@mui/icons-material/LocalPostOffice';
import CallIcon from '@mui/icons-material/Call';
import { Language } from '@mui/icons-material';

const ContactToSupportModal = ({ isOpen, onClose }) => {
    const { agency } = useUsersContext()

    const sanitizeEmail = (value) => {
        if (!value || typeof value !== 'string') return '';
        const str = value.trim();
        // Extract the first email-like token from the string
        const match = str.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i);
        if (!match) return '';
        return match[0].toLowerCase();
    }

    const isValidEmail = (value) => {
        if (!value) return false;
        // Basic validation only; avoids over-restricting legitimate emails
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    const emailHref = (() => {
        const email = sanitizeEmail(agency?.non_saas_email);
        // Avoid over-encoding; most clients accept plain `mailto:` with lowercase
        return isValidEmail(email) ? `mailto:${email}` : undefined;
    })();

    const telHref = (() => {
        const phone = (agency?.non_saas_phone || '').toString().trim();
        return `tel:${phone}`;
    })();
    return (
        <CommonModal showAlert={false} title='' isOpen={isOpen} onClose={onClose} hideCloseButton={false}>
            <div className='flex justify-center mb-4'>
                <div className='w-[100px]'>
                    {agency?.Customization?.logo ? (
                        <img src={agency?.Customization?.logo} alt="" />
                    ) : <SvgIcon id="maybeIcon" />}
                </div>
            </div>
            <p className='text-center text-lg font-medium'>Contact Us to Upgrade Your Plan</p>
            {agency?.non_saas_email && (emailHref ? (
                <a
                    href={emailHref}
                    onClick={(e) => {
                        e.stopPropagation();   // Prevent modal from blocking it
                    }}
                    className='border border-black rounded-sm w-full px-3 py-2 mt-3 mb-2 flex items-center justify-center gap-2'
                >
                    <LocalPostOfficeIcon />
                    <span className='whitespace-nowrap'>{agency?.non_saas_email}</span>
                </a>

            ) : (
                <button className='border border-black rounded-sm w-full px-3 py-2 mt-3 mb-2 flex items-center justify-center gap-2' disabled>
                    <LocalPostOfficeIcon /> <span>Send an Email</span>
                </button>
            ))}
            {agency?.non_saas_phone && <a href={telHref} className='bg-black text-white rounded-sm w-full px-3 py-2 mb-3 flex items-center justify-center gap-2'>
                <CallIcon /> <span>{agency?.non_saas_phone || '1111111111'}</span>
            </a>}
            {agency?.non_saas_website && <a href={agency?.non_saas_website?.includes('http') ? agency?.non_saas_website : `https://${agency?.non_saas_website}`} target="_blank" rel="noopener noreferrer" className='border border-black rounded-sm w-full px-3 py-2 mt-3 mb-2 flex items-center justify-center gap-2'>
                <Language /> <span>{agency?.non_saas_website}</span>
            </a>}
        </CommonModal>
    )
}

export default ContactToSupportModal